import { render, staticRenderFns } from "./Variationdetails.vue?vue&type=template&id=f9c60ab0"
import script from "./Variationdetails.vue?vue&type=script&lang=js"
export * from "./Variationdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports